import { forwardRef, SelectHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * Native `<select>` styled to match `Input` and `Button`.
 *
 * Height is `h-9` so it lines up with the other controls on a row. Pass
 * `h-8` when the whole row uses the small height — never a bare pixel value.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
	({ className, children, ...props }, ref) => (
		<select
			ref={ref}
			className={cn(
				"flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background",
				"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
				"disabled:cursor-not-allowed disabled:opacity-50",
				className,
			)}
			{...props}
		>
			{children}
		</select>
	),
);

Select.displayName = "Select";

type SelectItemProps = React.OptionHTMLAttributes<HTMLOptionElement>;

export function SelectItem({ children, ...props }: SelectItemProps) {
	return <option {...props}>{children}</option>;
}
